import { Component, inject } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { SignalsStoreService } from '../../signals-store.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-pending-payment-method',
  providers: [provideNativeDateAdapter()],
  imports: [],
  template: `
    <div class="container mt-3">
      <div class="row">
        <div class="col mb-3 text-center">
          <span class="h5-regular">
          <p>In order to start adding items to your basket you need to add a payment method to your account.</p>
          <p class="fw-semibold">We will not bill you anything until the day of your delivery.</p>
          <p>Click the button below to add your payment info.</p>          
          </span>
        </div>
      </div>

      <div class="row mt-0 mb-2 mt-3 justify-content-center">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <button
            type="button"
            class="btn btn-primary w-100"
            (click)="reloadPage('/signup')">
            Finalize My Account
          </button>
        </div>
      </div>
    </div>
  `
})
export class PendingPaymentMethodComponent {
  private signalsStoreService = inject(SignalsStoreService)
  private location = inject(Location);

  reloadPage(route: string) {
    // Setting step 3 
    this.signalsStoreService.signUpStep.set(2)
    this.location.replaceState(route);
    window.location.reload();
  }
}
